import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import SitePagination from 'containers/SitePagination';
import { selectors } from '../ducks/list.duck';

const getPaginationData = createSelector(
  selectors.pagination,
  R.applySpec({
    totalItems: R.prop('totalItems'),
    perPage: R.prop('perPage'),
    currentPage: R.prop('currentPageUI'),
  }),
);

const Pagination = connect(state => ({
  ...getPaginationData(state),
  loading: selectors.loading(state),
}))(SitePagination);

export default Pagination;
